<template>
  <div class="container">
		<!-- banner -->
		<el-carousel trigger="click" class="carousel" :interval="5000" :initial-index="1" :loop="true">
		      <el-carousel-item v-for="(item, index) in content.carousel" :key="index">
		        <!-- <div class="banner pr" :style="'background: url('+item.cover+') no-repeat right center/cover'"> -->
				<div class="banner pr">
					<div class="img"><img :src="item.cover" alt=""></div>
					<a :href="item.url" v-if="item.url" class="ab" target="_blank"></a>
		        	<div class="text ab">
		        		<div class="w1600 d-flex j-end">
		        			<div class="desc">
		        				<p class="en font-light line-mn">
		        					{{item.title}}<br>{{item.subTitle}}
		        				</p>
		        				<p class="cn font-light font20 line-mn">
		        					{{item.description}}
		        				</p>
		        			</div>
		        		</div>
		        	</div>
		        </div>
		      </el-carousel-item>
		</el-carousel>
		
		
		<!-- 列表 -->
		<div class="homeSlide">
			<ul>
				<li class="d-flex a-center" v-for="(item, index) in content.list" :key="index">
					<div class="text d-flex j-sb a-center">
						<figure v-if="item.cover"><img :src="item.cover" class="w100" alt=""></figure>
						<div class="intro">
							<h3 class="h3 font36"><a href="">{{item.title}}</a></h3>
							<div class="desc font-light line-md">
								{{item.description}}
							</div>
							<div class="more">
								<!-- 外链 -->
								<a :href="item.url" target="_blank" v-if="item.url" class="font-light t-sion">{{$t('show.lookDetail')}}</a>
								<!-- 详情 -->
								<a v-else class="font-light t-sion pointer" @click="goToPage('/articleDetail?id='+item.id)">{{$t('show.lookDetail')}}</a>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
  </div>
</template>

<script>

export default {
  name: 'HomeContent',
  components: {
    
  },
  data() {
	  return {
		  bannerBg: require('@/assets/Home/banner.jpg'),
		  // 详细内容
		  content: {}
	  }
  },
  
  created() {
  	  // 获取详细信息
  	  this.getContentInfo();
  	 
  },
  
  methods: {
	  // 获取详细信息
	  getContentInfo() {
		  this.$axios.get(`index/content`)
		  .then(res => {
			  // 轮播图会在2个的情况下出现循环错误问题，所以需要添加对应数据
			  if(res.data.carousel.length == 2) {
				  res.data.carousel.unshift(res.data.carousel[1]);
				  res.data.carousel.push(res.data.carousel[1]);
			  }
			  this.content = res.data;
		  })
		  .catch(err=>{})
	  },
	  
	  // 页面跳转
	  goToPage(path, query={}) {
	  		  this.$router.push({
	  			path,
	  			query
	  		  })
	  }
  }
}
</script>

<style lang="less" scoped>
	.el-carousel{
		height: auto;
		
		/deep/ .el-carousel__container{
			//height: 6rem;
			height: auto;
			padding-bottom: 32.3%;
			@media (max-width: 1200px) {
				//height: 4rem;
			}
			@media (max-width: 640px) {
				//height: 3rem;
			}
		}
	}
	.banner{
		//height: 6rem;
		.img{
			img{
				display: block;
				width: 100%;
			}
		}
		> a.ab{
			z-index: 6;
		}
		.text{
			.desc{
				width: 7rem;
				max-width: 100%;
				padding-top: 1.5rem;
				@media (max-width: 1600px) {
					padding-top: 1rem;
				}
				.en{
					font-size: .5rem;
					color: #fff;
				}
				.cn{
					color: #74edff;
					margin-top: .1rem;
				}
			}
		}
		@media (max-width: 1200px) {
			//height: 4rem;
			.text{
				.desc{
					.en{
						font-size: .35rem;
					}
				}
			}
		}
		@media (max-width: 640px) {
			//height: 3rem;
			.text{
				.desc{
					padding-top: .3rem;
				}
			}
		}
	}
	.homeSlide{
		ul{
			li{
				height: 6rem;
				&:nth-of-type(odd) {
					background: url(@/assets/Home/bg1.jpg) no-repeat right center/cover;
					.text{
						flex-direction: row-reverse;
					}
					
				}
				&:nth-of-type(even) {
					background: url(@/assets/Home/bg2.jpg) no-repeat right center/cover;
					
				}
				.text{
					width: 80%;
					max-width: 1300px;
					margin: 0 auto;
					figure{
						width: 32%;
					}
					.intro{
						width: 52.5%;
						.desc{
							margin: .2rem 0 .3rem;
						}
						.more a{
							display: block;
							width: 1.3rem;
							height: .45rem;
							line-height: .45rem;
							border-radius: .45rem;
							color: #fff;
							text-indent: .25rem;
							background: url(@/assets/Icons/arrowRightWhite.png) no-repeat 1rem center/.08rem, url(@/assets/Home/moreBg.png) no-repeat center/100% 100%;
							&:hover{
								box-shadow: 3px 3px 5px rgba(40,90,219,.3);
							}
						}
					}
				}
			}
		}
		@media (max-width: 1200px) {
			ul{
				li{
					height: 4rem;
				}
			}
		}
		@media (max-width: 640px) {
			ul{
				li{
					height: auto;
					padding: .5rem 0;
					.text{
						width: 95%;
						.intro{
							width: 62.5%;
						}
					}
				}
			}
		}
	}
</style>
